export default function () {
  const { config } = useFrontendConfiguration()

  return useScriptMetaPixel({
    id: config.value!.metaPixelId,
    scriptOptions: {
      trigger: 'manual',
    },
  })
}
